var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.id}},[_c('video',{ref:"cam",staticClass:"camera",style:("width:"+_vm.size+"px;"),attrs:{"id":_vm.id+"Cam","muted":"","playsinline":""},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }